export default __webpack_public_path__ + "817ca1c921ddf60c60b6b7f3921a416b.jpg";